export default "__VITE_ASSET__CrK$BwsU__"